import { render, staticRenderFns } from "./ProdukUpload.vue?vue&type=template&id=b6e17344&scoped=true"
import script from "./ProdukUpload.vue?vue&type=script&lang=js"
export * from "./ProdukUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e17344",
  null
  
)

export default component.exports